import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { realRoleNames } from 'cassandra-shared-js/roles';
import AppTable from '../../basic/AppTable';
import { filterTypes } from '../../basic/AdvancedFilters';
import { parseDate } from '../consents/ConsentsTable';
import { useItems } from '../../../hooks/atoms/items-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

const tableColumns = [
  { id: 1, label: 'ID', field: 'id' },
  { id: 2, label: 'Name', field: 'name' },
  { id: 3, label: 'Surname', field: 'family_name' },
  { id: 5, label: 'E-mail', field: 'email' },
  { id: 9, label: 'Username', field: 'username' },
  { id: 6,
    label: 'Role',
    field: 'role.name',
    customRenderer({ row }) {
      const foundRole = Object.values(realRoleNames).find((val) => {
        return val.value === row.role.name;
      });

      const value = foundRole?.name ?? '';

      return (
        <>
          {value}
        </>
      );
    } },
  { id: 7,
    label: 'Updated At',
    field: 'updated_at',
    customRenderer({ row }) {
      return (
        <>
          {parseDate(row.updated_at)}
        </>
      );
    } },
  { id: 8,
    label: 'Created At',
    field: 'created_at',
    customRenderer({ row }) {
      return (
        <>
          {parseDate(row.created_at)}
        </>
      );
    } },
];

const UsersTable = () => {
  const [ filterQuery, setFilterQuery ] = useState({});

  const {
    items: users,
    itemsLoading: usersLoading,
    pagination,
  } = useItems(CollectionKeys.ADMIN_TOOL_USERS, { filterQuery });

  const location = useLocation();
  const history = useHistory();

  const handleViewAction = (e, userId) => {
    history.push({
      pathname: location.pathname,
      search: `?id=${ userId }`,
    });
  };

  return (
    <>
      <AppTable
        columns={ tableColumns }
        data={ users }
        loading={ usersLoading }
        paginationProps={ pagination }
        advancedFiltersProps={ {
          properties: [
            {
              value: 'name',
              label: 'Name',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'family_name',
              label: 'Surname',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'email',
              label: 'E-mail',
              type: filterTypes.FREE_TEXT,
            },
          ],
          initialAndFilterOptions: [],
          onQueryChange: setFilterQuery,
        } }
        ViewProp={ { handleView: handleViewAction } }
      />
    </>
  );
};

export default UsersTable;

